import PropTypes from "prop-types";

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  employer: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  createdAt: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  average: PropTypes.number.isRequired,
});
